// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Next = require("../../reason/next/Next.bs.js");
var Utils = require("../../utils/Utils.bs.js");
var IconV5 = require("../../uikit/atoms/Icon/IconV5.bs.js");
var Link = require("next/link").default;
var FeaturesV3 = require("../../reason/featureFlipper/FeaturesV3.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var UserSession = require("../../reason/common/UserSession/UserSession.bs.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var TailwindMerge = require("tailwind-merge");
var JsxRuntime = require("react/jsx-runtime");
var RescriptRelay_Query = require("rescript-relay/src/RescriptRelay_Query.bs.js");
var MarketingProfileSubpages = require("./MarketingProfileSubpages.bs.js");
var SettingsPageSidebarQuery_graphql = require("../../__generated__/SettingsPageSidebarQuery_graphql.bs.js");

function SettingsPageSidebar$SidebarLink(props) {
  var __childLinks = props.childLinks;
  var url = props.url;
  var name = props.name;
  var childLinks = __childLinks !== undefined ? __childLinks : [];
  var router = Next.useRouter();
  var query = Next.Router.query(router);
  var currentSettingPath = (function (__x) {
        return Utils.$$Array.joinWith("/", __x);
      })(Core__Option.getOr(query["setting"], []));
  var currentPath = "/account/" + currentSettingPath;
  var current = currentPath === url;
  if (childLinks.length === 0) {
    return JsxRuntime.jsx(Link, {
                href: url,
                passHref: true,
                className: TailwindMerge.twMerge([
                      current ? "bg-zinc-50 text-zinc-900 hover:text-zinc-900 focus:text-zinc-900" : "hover:bg-zinc-50 hover:text-zinc-900 text-zinc-700",
                      "flex rounded-md p-2 text-base leading-6 font-semibold "
                    ]),
                children: Caml_option.some(name)
              });
  }
  var isOpen = currentPath.startsWith(url);
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                JsxRuntime.jsxs(Link, {
                      href: url,
                      className: TailwindMerge.twMerge([
                            current ? "bg-zinc-50 text-zinc-900 hover:text-zinc-900 focus:text-zinc-900" : "hover:bg-zinc-50 hover:text-zinc-900 text-zinc-700",
                            "flex items-center rounded-md p-2 text-base leading-6 font-semibold"
                          ]),
                      children: [
                        name,
                        JsxRuntime.jsx(IconV5.make, {
                              icon: "arrow-right",
                              className: TailwindMerge.twMerge([
                                    isOpen ? "rotate-90 text-zinc-500" : "text-zinc-400",
                                    "ml-auto h-4 w-4 shrink-0"
                                  ])
                            })
                      ]
                    }),
                isOpen ? JsxRuntime.jsx("ul", {
                        children: childLinks.map(function (childLink) {
                              var isCurrent = currentPath === childLink.url;
                              return JsxRuntime.jsx("li", {
                                          children: JsxRuntime.jsxs(Link, {
                                                href: childLink.url,
                                                className: TailwindMerge.twMerge([
                                                      isCurrent ? "bg-zinc-50 text-zinc-900 hover:text-zinc-900 focus:text-zinc-900 font-semibold" : "hover:bg-zinc-50 hover:text-zinc-900 text-zinc-700",
                                                      "block rounded-md py-2 pr-2 pl-9 text-base leading-6 "
                                                    ]),
                                                children: [
                                                  JsxRuntime.jsx("span", {
                                                        children: name + " - ",
                                                        className: "sr-only"
                                                      }),
                                                  childLink.name
                                                ]
                                              })
                                        }, childLink.name);
                            }),
                        className: "mt-1 px-2"
                      }) : null
              ]
            });
}

var SidebarLink = {
  make: SettingsPageSidebar$SidebarLink
};

var convertVariables = SettingsPageSidebarQuery_graphql.Internal.convertVariables;

var convertResponse = SettingsPageSidebarQuery_graphql.Internal.convertResponse;

var convertWrapRawResponse = SettingsPageSidebarQuery_graphql.Internal.convertWrapRawResponse;

var use = RescriptRelay_Query.useQuery(convertVariables, SettingsPageSidebarQuery_graphql.node, convertResponse);

var useLoader = RescriptRelay_Query.useLoader(convertVariables, SettingsPageSidebarQuery_graphql.node, (function (prim) {
        return prim;
      }));

var usePreloaded = RescriptRelay_Query.usePreloaded(SettingsPageSidebarQuery_graphql.node, convertResponse, (function (prim) {
        return prim;
      }));

var $$fetch = RescriptRelay_Query.$$fetch(SettingsPageSidebarQuery_graphql.node, convertResponse, convertVariables);

var fetchPromised = RescriptRelay_Query.fetchPromised(SettingsPageSidebarQuery_graphql.node, convertResponse, convertVariables);

var retain = RescriptRelay_Query.retain(SettingsPageSidebarQuery_graphql.node, convertVariables);

var Query = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  use: use,
  useLoader: useLoader,
  usePreloaded: usePreloaded,
  $$fetch: $$fetch,
  fetchPromised: fetchPromised,
  retain: retain
};

function SettingsPageSidebar$MarketingProfileSidebarLinks(props) {
  var match = use(undefined, undefined, undefined, undefined);
  var subpages = MarketingProfileSubpages.useSubpagesForCurrentAccount(Core__Option.map(match.currentAccountV5.marketingProfile, (function (x) {
              return x.fragmentRefs;
            })));
  if (subpages !== undefined) {
    if (subpages.TAG === "AgentPages") {
      return JsxRuntime.jsx(SettingsPageSidebar$SidebarLink, {
                  name: "Marketing Profile",
                  url: "/account/marketing_profile",
                  childLinks: subpages._0.map(function (page) {
                        return {
                                name: page.displayName,
                                url: page.path
                              };
                      })
                });
    } else {
      return JsxRuntime.jsx(SettingsPageSidebar$SidebarLink, {
                  name: "Team Marketing Profile",
                  url: "/account/team_marketing_profile",
                  childLinks: subpages._0.map(function (page) {
                        return {
                                name: page.displayName,
                                url: page.path
                              };
                      })
                });
    }
  } else {
    return JsxRuntime.jsx(SettingsPageSidebar$SidebarLink, {
                name: "Marketing Profile",
                url: "/account/marketing_profile"
              });
  }
}

var MarketingProfileSidebarLinks = {
  make: SettingsPageSidebar$MarketingProfileSidebarLinks
};

function SettingsPageSidebar(props) {
  var marketingProfileSettingsEnabled = FeaturesV3.useFeatureFlipper("MarketingProfileSettings") === "on";
  var billingPageEnabled = UserSession.useChapterPreference("PayingChapter") === "ON";
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx(SettingsPageSidebar$SidebarLink, {
                      name: "TAN Profile",
                      url: "/account/profile"
                    }),
                JsxRuntime.jsx(SettingsPageSidebar$SidebarLink, {
                      name: "Password",
                      url: "/account/password"
                    }),
                JsxRuntime.jsx(SettingsPageSidebar$SidebarLink, {
                      name: "Email Notifications",
                      url: "/account/email_notifications"
                    }),
                JsxRuntime.jsx(SettingsPageSidebar$SidebarLink, {
                      name: "Account Users",
                      url: "/account/users"
                    }),
                billingPageEnabled ? JsxRuntime.jsx(SettingsPageSidebar$SidebarLink, {
                        name: "Billing",
                        url: "/account/billing"
                      }) : null,
                marketingProfileSettingsEnabled ? JsxRuntime.jsx(SettingsPageSidebar$MarketingProfileSidebarLinks, {}) : null
              ],
              className: "bg-white space-y-1 p-3 rounded shadow-sm"
            });
}

var make = SettingsPageSidebar;

exports.SidebarLink = SidebarLink;
exports.Query = Query;
exports.MarketingProfileSidebarLinks = MarketingProfileSidebarLinks;
exports.make = make;
/* use Not a pure module */
